<template>
  <v-container fluid>
    <notifications
      group="slideshowOperations"
      position="bottom right"
      style="direction:rtl"
    />
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
        <div class="page-title">
          <v-icon color="baseColor">fas fa-tachometer-alt</v-icon>
          مدیریت اسلاید شو فروشگاه
        </div>
      </v-flex>
      <v-flex xs12 sm12 md3 lg3 xl3 style="padding-right:20px;padding-left:20px"
        ><!--Slider Titles Section-->
        <v-form ref="titlesFrom">
          <v-card>
            <v-card-title>
              عنوان اسلایدر
            </v-card-title>
            <v-layout row wrap>
              <v-flex
                style="padding-right:20px;padding-left:20px"
                xs12
                sm12
                md12
                lg12
                xl12
              >
                <v-text-field
                  :rules="[rules.required]"
                  dense
                  v-for="(item,index) in titles"
                  :key="index"
                  append-icon="fas fa-heading"
                  v-model="titles[index]"
                  outlined
                  :label="inputLabels[index] "
                  :hint="inputLabels[index] "
                ></v-text-field>
                <v-text-field
                  :rules="[rules.required]"
                  dense
                  append-icon="fas fa-heading"
                  v-model="btnTitle"
                  outlined
                  label="عنوان دکمه"
                ></v-text-field>
                <custom-picker @Selected="bgColor=$event" label="رنگ زمینه" :color="bgColor"></custom-picker>
                <custom-picker @Selected="btnColor=$event" label="رنگ دکمه" :color="btnColor"></custom-picker>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-flex>
      <v-flex xs12 sm12 md3 lg3 xl3>
        <v-card>
          <v-card-title>
            <v-toolbar dense flat>
              <v-toolbar-title>
                سایر تنظیمات اسلایدر
              </v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <v-layout row wrap>
                <v-flex xs6 sm6 md6 lg6 xl6 style="padding:20px"
                  >وضعیت :
                </v-flex>
                <v-flex xs6 sm6 md6 lg6 xl6 style="text-align:left;padding:20px"
                  ><v-switch
                    color="blue darken-4"
                    v-model="slideShowStatus"
                    class="d-flex flex-row mb-6 justify-end align-self-start"
                    id="sliderStatus"
                  ></v-switch
                ></v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              sm12
              md12
              lg12
              xl12
              style="padding-right:20px;padding-left:20px"
            >
              <v-text-field
                dense
                append-icon="fas fa-sort-amount-up-alt"
                v-model="txtSort"
                @keypress="isNumber($event)"
                outlined
                label="ترتیب"
                hint="ترتیب نمایش"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md12
              lg12
              xl12
              style="padding-right:20px;padding-left:20px"
            >
              <v-text-field
                dense
                append-icon="fas fa-link"
                v-model="txtVirtualLink"
                outlined
                label="لینک"
                hint="لینک اسلایدر"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md12
              lg12
              xl12
              style="padding-right:20px;padding-left:20px"
            >
              <v-text-field
                dense
                append-icon="fas fa-eye-slash"
                v-model="txtAlt"
                outlined
                label="َAlt"
                hint="متن جایگزین در صورت خراب بودن لینک عکس"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md12
              lg12
              xl12
              style="padding-right:20px;padding-left:20px"
            >
              <v-text-field
                dense
                append-icon="fas fa-tag"
                v-model="txtTitle"
                outlined
                label="Title"
                hint="Title"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 xl6 style="padding-right:20px;padding-left:20px"
        ><!--Slider Media Section-->
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <v-card-title>
                <v-toolbar dense flat extended>
                  <v-toolbar-title>
                    چندرسانه ای
                  </v-toolbar-title>
                  <v-layout row wrap slot="extension">
                    <v-flex xs5 sm5 md5 lg5 xl5 style="padding:20px">
                      <v-btn
                        color="baseColor"
                        @click="registerSlider"
                        :loading="inRegisteringSlider"
                        dark
                        block
                        ><v-icon small style="padding-left:5px"
                          >fas fa-check</v-icon
                        >ذخیره</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-toolbar>
              </v-card-title>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                  <div class="devices">
                    <div class="desktop">
                      <div class="desktop-img-holder">
                        <v-overlay absolute>
                          <f-up :hideExternal="true" @RetunedFileName="handleDesktopUpload" Root="SLIDER" Folder="NONE" BtnTitle="انتخاب عکس"></f-up> 
                         
                         
                        </v-overlay>
                        <v-img
                          width="100%"
                          v-if="toggleMediaType == 2"
                          height="100%"
                          :src="desktopImage"
                        ></v-img>
                      </div>
                    </div>
                    <div class="mobile">
                      <div class="mobile-img-holder">
                        <v-overlay absolute>
                          <f-up :hideExternal="true" @RetunedFileName="handleMobileUpload" Root="SLIDER" Folder="NONE" BtnTitle="انتخاب عکس"></f-up> 
                         
                         
                        </v-overlay>
                        <v-img
                          width="100%"
                          v-if="toggleMediaType == 2"
                          height="100%"
                          :src="mobileImage"
                        ></v-img>
                      </div>
                    </div>
                  </div>
                </v-flex>
                
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-divider></v-divider>
        <div class="page-title">
          <v-icon color="baseColor">fas fa-archive</v-icon>آرشیو اسلایدر
        </div>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card>
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-data-table
              :items="dtData"
              :loading="dtLoading"
              :headers="dtHeaders"
            >
              <template v-slot:[`item.s_DesktopFileLink`]="{ item }">
                <v-icon
                  color="blue darken-4"
                  small
                  @click="displayFile(item.s_DesktopFileLink)"
                  >fas fa-eye</v-icon
                >
              </template>
              <template v-slot:[`item.s_MobileFileLink`]="{ item }">
                <v-icon
                  color="blue darken-4"
                  small
                  @click="displayFile(item.s_MobileFileLink)"
                  >fas fa-eye</v-icon
                >
              </template>
              <template v-slot:[`item.s_Status`]="{ item }">
                <v-chip
                  v-if="item.s_Status == true"
                  @click="disableSlider(item)"
                  dark
                  color="green lighten-1"
                  >فعال</v-chip
                >
                <v-chip
                  v-if="item.s_Status == false"
                  @click="enableSlider(item)"
                  dark
                  color="red lighten-1"
                  >غیر فعال</v-chip
                >
              </template>
              <template v-slot:[`item.operation`]="{ item }">
                <v-icon small color="baseColor" @click="editSlider(item)"
                  >fas fa-edit</v-icon
                >
                <v-icon class="padding-left:3px" small color="red" @click="confirmDeleteItem(item.s_Id)"
                >fas fa-trash</v-icon
              >
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <template><!--Delete Confirm Dialog-->
      <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
          <v-card>
              <v-card-title style="padding:0px !important">
                  <v-app-bar dense color="rgb(42, 45, 69)" dark>
                      <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                  </v-app-bar>
              </v-card-title>
              <v-card-text style="padding-top:15px;">
                  <v-alert type="error" outlined>
                      کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                  </v-alert>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                  <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
              </v-card-actions>
          </v-card>
      </v-dialog>
  </template>
  </v-container>
</template>
<style>
.image-input__container {
  width: 100% !important;
}
</style>
<style scoped>
 .page-title
 {
  display: block;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
 }
.mobile-img-holder {
  display: block;
  width: 114px;
  top: 25%;
  margin: auto;
  height: 49%;
  right: -1px;
  position: relative;
}
.desktop-img-holder {
  display: block;
  width: 82%;
  top: 18%;
  margin: auto;
  height: 48%;
  right: -1px;
  position: relative;
}
.devices
{
  width: 100%;
  display: grid;
  grid-template-columns: 50% 40%;
}
.mobile {
  width: 100%;
  height: 326px;
  background-image: url(../../../assets/mobile.png);
  /* background-size: 100% 100%; */
  -o-object-fit: contain;
  object-fit: contain;
  background-position: center;
  background-size: 76% 76%;
}
.desktop {
  width: 100%;
  height: 326px;
  background-image: url(../../../assets/desktop.png);
  /* background-size: 100% 100%; */
  -o-object-fit: contain;
  object-fit: contain;
  background-position: center;
  background-size: 90% 75%;
}
</style>
<script>
const ApiUrl = require("../../../constant/apiurl");
const axios = require("axios");
import EleUploadVideo from "vue-ele-upload-video";
import UploadImage from "vue-upload-image";
import imguploader from "../../../components/upload.vue";
export default {
  name: "slideshowshop",
  components: {
    UploadImage,
    imguploader,
    EleUploadVideo
  },
  data: () => ({
    /*******Table Information********* */
    dtHeaders: [
      { text: "#", value: "counter", align: "right", sortable: true },
      {
        text: "عناوین اسلایدر",
        value: "s_Titles",
        align: "right",
        sortable: true
      },
      {
        text: "ترتیب نمایش",
        value: "s_OrderField",
        align: "right",
        sortable: true
      },
      { text: "Alt", value: "s_AltTag", align: "right", sortable: true },
      {
        text: "Tooltip Title",
        value: "s_TooltipTitle",
        align: "right",
        sortable: true
      },
      {
        text: "نمایش عکس",
        value: "s_DesktopFileLink",
        align: "right",
        sortable: true
      },
      // {
      //   text: "فایل موبایل",
      //   value: "s_MobileFileLink",
      //   align: "right",
      //   sortable: true
      // },
      {
        text: "وضعیت نمایش",
        value: "s_Status",
        align: "right",
        sortable: true
      },
      { text: "عملیات", value: "operation", align: "right", sortable: true }
    ],
    dtLoading: false,
    dtData: [],
    /**************** */
    inRegisteringSlider: false,
    txtSort: "",
    txtVirtualLink: "",
    inUploading: false,
    txtAlt: "",
    txtTitle: "",
    bgColor:"#ffffff",
    btnColor:"#ffffff",
    titles:[null,null,null],
    inputLabels:["عنوان اصلی","عنوان نمایشی 1","عنوان نمایشی 2"],
    rules: {
      required: val => !!val || "این فیلد الزامی میباشد"
    },
    btnTitle:"",
    videoUploadProgress: 0,
    video: "",
    token: "",
    imageData: "",
    selectImageForMobile: false,
    selectImageForDesktop: false,
    toggleMediaType: 2,
    slideTitleCount: 1,
    desktopImage: "",
    mobileImage: "",
    videoSrc: "",
    slideShowStatus: true,
    respDeskVideoFileName: "",
    respDeskImageFileName: "",
    respMobileFileName: "",
    inEditItem: "",
    inEditSlider: false,
    showAnimationOver: false,
    showFloatButtons: false,
    EDTITEM:{},
    ConfirmItemDeleteDialog:false,
    deleteBtnLoading:false,
    deleteItemId:0,
    
  }),
  computed: {
    LANG() {
      return this.$store.getters.GetLang;
    }
  },
  watch: {
    LANG(nL, oL) {
      this.loadSliders();
    }
  },
  methods: {
    async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.S_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteSlider,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    // MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadSliders();
                }
                else
                {
                    // MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                // MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
    async enableSlider(sitem) {
      let vm = this;
      let url =
        ApiUrl.ActiveSlider;
      let data = {};
      data.S_Id= sitem.s_Id;
      const config = {
        url: url,
        method: "post",
        data: data
      };
      await axios(config)
        .then(function(res) {
          if (res.data.status == 1) {
            vm.loadSliders();
          } else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async disableSlider(sitem) {
      let vm = this;
      let url =
        ApiUrl.DisableSlider;
        console.warn(sitem);
      let data = {};
      data.S_Id= sitem.s_Id;
      const config = {
        url: url,
        method: "post",
        data: data
      };
      await axios(config)
        .then(function(res) {
          if (res.data.status == 1) {
            vm.loadSliders();
          } else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    resetForm() {
      let vm = this;
      vm.slideTitleCount = 1;
      vm.titles = ["","",""];
      vm.txtSort = "";
      vm.txtVirtualLink = "";
      vm.txtAlt = "";
      vm.txtTitle = "";
      vm.slideShowStatus = true;
      vm.mobileImage = "";
      vm.desktopImage = "";
      vm.toggleMediaType = 2;
      vm.inEditItem = [];
      vm.EDTITEM = [];
      vm.inEditSlider = false;
      vm.showAnimationOver = false;
      vm.showFloatButtons = false;
      vm.btnTitle = "";
      vm.btnColor = "";
      vm.bgColor = "";
    },
    editSlider(sitem) {
      console.error(sitem);
      let vm = this;
      vm.bgColor = sitem.s_BgColor;
      vm.btnColor = sitem.s_BtnColor;
      vm.btnTitle = sitem.s_BtnText;
      vm.EDTITEM = sitem;
      vm.titles = sitem.s_Titles.split(',');
      vm.txtSort = sitem.s_OrderField;
      vm.txtVirtualLink = sitem.s_Link;
      vm.txtAlt = sitem.s_AltTag;
      vm.txtTitle = sitem.s_TooltipTitle;
      vm.slideShowStatus = sitem.s_Status;
      vm.mobileImage = ApiUrl.SliderUrl + sitem.s_MobileFileLink;
      vm.respMobileFileName = sitem.s_MobileFileLink;
      vm.desktopImage = ApiUrl.SliderUrl + sitem.s_DesktopFileLink;
      vm.toggleMediaType = 2;
      vm.respDeskImageFileName = sitem.s_DesktopFileLink;

      vm.inEditItem = sitem;

      vm.inEditSlider = true;
      vm.showAnimationOver = sitem.s_ShowAnimation;
      vm.showFloatButtons = sitem.s_ShowButtons;
    },
    displayFile(file) {
      window.open(ApiUrl.SliderUrl + file, "_blank");
    },
    async loadSliders() {
      var vm = this;
      var url = ApiUrl.LoadSlider+"/"+vm.LANG+"/12";

      vm.dtLoading = true;
      await axios
        .post(url )
        .then(function(res) {
          console.warn(res.data);
          vm.dtLoading = false;
          if (res.data.status) {
            vm.dtData = res.data.data;
          }
        })
        .catch(function(error) {
          vm.dtLoading = false;
          console.log(error);
        });
    },
    async registerSlider() {
      var vm = this;

      
        vm.inRegisteringSlider = true;
        var data = {};
        data.S_Titles = vm.titles.join(',');
        data.S_OrderField = parseInt(vm.txtSort);
        data.S_Link = vm.txtVirtualLink;
        data.S_AltTag = vm.txtAlt;
        data.S_TooltipTitle = vm.txtTitle;
        data.S_DesktopFileLink = vm.respDeskImageFileName;
        data.S_MobileFileLink = vm.respMobileFileName;
        data.S_Status = vm.slideShowStatus;
        data.S_ShowAnimation = vm.showAnimationOver;
        data.S_ShowButtons = vm.showFloatButtons;
        data.S_BgColor = vm.bgColor;
        data.S_BtnText = vm.btnTitle;
        data.S_BtnColor = vm.btnColor;
        data.S_Type = 12;
        data.Lang = "fa";
        var url = ApiUrl.AddSlider;
        if (vm.inEditSlider) {
          console.warn(vm.EDTITEM);
          data.S_Id = vm.EDTITEM.s_Id;
          url = ApiUrl.updateSlider;
        }

        
        await axios
          .post(url, data)
          .then(function(res) {
            vm.resetForms();
            vm.inRegisteringSlider = false;
            if (res.data.status) {
              vm.resetForm();
              vm.$notify({
                type: "success",
                group: "slideshowOperations",
                title: "عملیات موفق",
                text: res.data.data
              });
              vm.loadSliders();
            } else {
              vm.$notify({
                type: "error",
                group: "slideshowOperations",
                title: "خطا",
                text: res.data.data
              });
            }
          })
          .catch(function(error) {
            vm.inRegisteringSlider = false;
            console.log(error);
          });
      
    },
    resetForms() {
      var vm = this;
      vm.$refs.titlesFrom.reset();
      vm.slideTitleCount = 1;
      vm.toggleMediaType = 2;
      vm.respDeskVideoFileName = "";
      vm.respDeskImageFileName = "";
      vm.respMobileFileName = "";
      vm.slideShowStatus = true;
      vm.desktopImage = "";
      vm.mobileImage = "";
      vm.videoSrc = "";
      vm.imageData = "";
      vm.txtSort = "";
      vm.txtVirtualLink = "";
      vm.inUploading = false;
      vm.txtAlt = "";
      vm.txtTitle = "";
      vm.titles=["","",""];
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    decreaseSlideTitleCount() {
      let vm = this;
      if (vm.slideTitleCount > 1) {
        vm.slideTitleCount--;
      }
    },
    increaseSlideTitleCount() {
      let vm = this;
      if (vm.slideTitleCount < 4) {
        vm.slideTitleCount++;
      }
    },

    handleMobileUpload(res) {
     let vm  = this;
        vm.mobileImage = ApiUrl.SliderUrl + res;
        vm.selectImageForMobile = false;
        vm.respMobileFileName = res;
      
    },
    handleDesktopUpload(res) {
      let vm = this;
      
        vm.desktopImage = ApiUrl.SliderUrl + res;
        vm.respDeskImageFileName =res;
        vm.selectImageForDesktop = false;
      
    },
    updateImageData: function(newData) {
      this.imageData = newData;
    }
  },
  created() {
    this.loadSliders();
  }
};
</script>
<style >
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>
